/* Query-string builders for the dayzmetrics API, shared by the site's fetch
   client and the launcher's IPC client so the two can never disagree about a
   parameter name. Moved verbatim from player/src/api.ts. */
import type { ServerFilters, SimilarQuery } from './types'

export function serversQuery(f: ServerFilters): string {
  const p = new URLSearchParams()
  if (f.q) p.set('q', f.q)
  if (f.country?.length) p.set('country', f.country.join(','))
  if (f.map?.length) p.set('map', f.map.join(','))
  if (f.mod?.length) p.set('mod', f.mod.join(','))
  if (f.min_players) p.set('min_players', f.min_players)
  if (f.max_players) p.set('max_players', f.max_players)
  if (f.vanilla) p.set('vanilla', f.vanilla)
  if (f.hide_empty) p.set('hide_empty', '1')
  if (f.hide_full) p.set('hide_full', '1')
  if (f.open_only) p.set('open_only', '1')
  if (f.pp?.length) p.set('pp', f.pp.join(','))
  if (f.wiped) p.set('wiped', '1')
  if (f.wipe) p.set('wipe', f.wipe)
  if (f.ids?.length) p.set('ids', f.ids.join(','))
  if (f.featured) p.set('featured', '1')
  if (f.daynight) p.set('daynight', f.daynight)
  if (f.scope) p.set('scope', f.scope)
  if (f.mode) p.set('mode', f.mode)
  if (f.noAi) p.set('no_ai', String(f.noAi))
  if (f.igFrom != null) p.set('ig_from', String(f.igFrom))
  if (f.igTo != null) p.set('ig_to', String(f.igTo))
  if (f.vsFrom != null) p.set('vs_from', String(f.vsFrom))
  if (f.vsTo != null) p.set('vs_to', String(f.vsTo))
  p.set('sort', f.sort || 'players')
  p.set('dir', f.dir || 'desc')
  p.set('fakes', f.fakes || 'hide')
  p.set('online', f.online === false ? '0' : '1')
  p.set('limit', String(f.limit ?? 50))
  if (f.offset) p.set('offset', String(f.offset))
  return p.toString()
}

export type FiltersCtx = Pick<ServerFilters, 'scope' | 'mode' | 'online' | 'min_players' | 'max_players' | 'noAi'>

export function filtersQuery(ctx?: FiltersCtx): string {
  const p = new URLSearchParams()
  if (ctx?.scope) p.set('scope', ctx.scope)
  if (ctx?.mode) p.set('mode', ctx.mode)
  if (ctx?.online === false) p.set('online', '0')
  if (ctx?.min_players) p.set('min_players', ctx.min_players)
  if (ctx?.max_players) p.set('max_players', ctx.max_players)
  if (ctx?.noAi) p.set('no_ai', String(ctx.noAi))
  return p.toString()
}

/* /api/trending and /api/upcoming: optional country list and a limit. */
export function discoverQuery(country?: string[], limit = 12): string {
  const p = new URLSearchParams()
  if (country?.length) p.set('country', country.join(','))
  p.set('limit', String(limit))
  return p.toString()
}

/* /api/server/{id}/similar: sending any parameter switches the API from the
   legacy bare array to the paged {items, total, ...} shape. */
export function similarQuery(q: SimilarQuery = {}): string {
  const p = new URLSearchParams()
  p.set('same_map', q.sameMap ? '1' : '0')
  p.set('offset', String(q.offset ?? 0))
  p.set('limit', String(q.limit ?? 12))
  return p.toString()
}
